(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["archive"] && !Shopify.designMode) return;
  try {
    
  // 🪗 Accordion
  const accordions = document.querySelectorAll('.accordion');
  const floatingImage = document.querySelector('.blog-archive__floating-image');
  const defaultImage = floatingImage.querySelector('img');

  const toggleAccordion = (accordionButton) => {
    const symbol = accordionButton.querySelector('.accordion__symbol');

    // Close other accordion items
    accordions.forEach((otherAccordion) => {
      const otherAccordionButton = otherAccordion.querySelector('button');
      const otherSymbol = otherAccordionButton.querySelector('.accordion__symbol');
      if (otherAccordionButton !== accordionButton) {
        otherAccordionButton.setAttribute('aria-expanded', 'false');
        otherSymbol.textContent = '+';
      }
    });

    // Expand the accordion
    if (accordionButton.getAttribute('aria-expanded') !== 'true') {
      accordionButton.setAttribute('aria-expanded', 'true');
      symbol.textContent = '-';
    }
    // Close the accordion
    else {
      accordionButton.setAttribute('aria-expanded', 'false');
      symbol.textContent = '+';
    }
  };

  accordions.forEach((accordion) => {
    const accordionButton = accordion.querySelector('button');
    accordionButton.addEventListener('click', () => {
      toggleAccordion(accordionButton);
    });
  });

  // 🖼️ Floating image hover interactions
  let resetTimeout;

  const updateFloatingImage = (imageUrl) => {
    if (floatingImage && imageUrl) {
      const img = floatingImage.querySelector('img');
      if (img) {
        // Clear srcset to force browser to use the new src
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = imageUrl;
      }
    }
  };

  const resetFloatingImage = () => {
    // Clear any existing timeout
    if (resetTimeout) {
      clearTimeout(resetTimeout);
    }

    // Add a small delay before resetting to prevent flickering
    resetTimeout = setTimeout(() => {
      if (floatingImage && defaultImage) {
        const img = floatingImage.querySelector('img');
        if (img) {
          // Restore original srcset and sizes if they exist
          if (defaultImage.srcset) {
            img.setAttribute('srcset', defaultImage.srcset);
          }
          if (defaultImage.sizes) {
            img.setAttribute('sizes', defaultImage.sizes);
          }
          img.src = defaultImage.src;
        }
      }
    }, 100);
  };

  const cancelReset = () => {
    if (resetTimeout) {
      clearTimeout(resetTimeout);
      resetTimeout = null;
    }
  };

  // Accordion button hover
  accordions.forEach((accordion) => {
    const accordionButton = accordion.querySelector('button');

    accordionButton.addEventListener('mouseenter', () => {
      cancelReset(); // Cancel any pending reset

      // Find the first article for this season in the accordion content
      const accordionContent = accordion.querySelector('.accordion__content');
      const firstArticleLink = accordionContent.querySelector('.blog-archive__link');

      if (firstArticleLink && firstArticleLink.dataset.articleImage) {
        updateFloatingImage(firstArticleLink.dataset.articleImage);
      }
    });

    accordionButton.addEventListener('mouseleave', resetFloatingImage);
  });

  // Blog archive item hover
  const archiveItems = document.querySelectorAll('.blog-archive__item');
  archiveItems.forEach((item) => {
    const link = item.querySelector('a');

    link.addEventListener('mouseenter', () => {
      cancelReset(); // Cancel any pending reset
      if (link.dataset.articleImage) {
        updateFloatingImage(link.dataset.articleImage);
      }
    });

    link.addEventListener('mouseleave', resetFloatingImage);
  });

  } catch(e) { console.error(e); }
})();
})();
